const reactStopPropagation = <E = HTMLElement>(event: React.MouseEvent<E, MouseEvent>) => {
  event.stopPropagation()

  event.nativeEvent.stopImmediatePropagation()
}

export default reactStopPropagation
